module.exports = __webpack_public_path__ + "static/project-16h-0871950c8d20066f5e2cb6c44f7670cc.png";